import * as React from 'react';

// Constants
import { } from '../../constants/routes';

// Components
import Box from '../../components/Box';
import SlimCropper, { ISlim } from '../../components/SlimCropper';
import Typography from '../../components/Typography';

// Component
export interface IProps {
  image: string | null;
  onConfirm: (dataUrl: string) => void;
}
function AvatarStep(props: IProps) {
  return (
    <Box pa={3}>
      <Typography type="headline" align="center">
        Upload Avatar
      </Typography>
      <Typography type="subheading" align="center" color="textSecondary">
        Make your profile recognizable
      </Typography>
      <Box px={3} py={4}>
        <SlimCropper
          style={{
            height: 196,
            width: 196,
            margin: 'auto auto',
            boxShadow:
              '0px 3px 5px -1px rgba(0, 0, 0, 0.2),' +
              '0px 5px 8px 0px rgba(0, 0, 0, 0.14),' +
              '0px 1px 14px 0px rgba(0, 0, 0, 0.12)'
          }}
          ratio="1:1"
          minSize={{ width: 250, height: 250 }}
          forceSize={{ width: 256, height: 256 }}
          forceType="jpg"
          instantEdit={true}
          didConfirm={function(this: ISlim) {
            props.onConfirm(this.dataBase64.output.image);
          }}
          uploadBase64={true}
          initialImage={props.image}
          edit={false}
        />
      </Box>
    </Box>
  );
}

export default AvatarStep;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/SignUp/AvatarStep.tsx